
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421" viewBox="0 0 256 256"><path d="M127.874 0 252.75 64v128l-124.875 64L3 192V64L127.874 0Zm-15.087 136.526 11.185-29.77c2.384-6.52 5.136-17.727 5.136-17.727h.364s2.75 11.206 5.136 17.728l11.183 29.769h-33.004Zm-43.273 48.498h14.484c9.17 0 12.286-2.174 15.22-9.7l8.069-20.737h44.004l8.07 20.736c2.935 7.527 6.233 9.701 15.403 9.701h14.303v-18.562h-2.936c-3.115 0-4.585-.67-5.681-3.68l-38.507-96.496H116.82l-38.69 96.496c-1.099 3.01-2.564 3.68-5.684 3.68h-2.933v18.562h.001Z" style="stroke:#000;stroke-width:1px"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    